import { apiClient } from "./apiClient";
import type { ScreenCategoryDefinition } from "../constants/screenCatalogCategories";

export type RoleAdminListItem = {
  id: number;
  nome: string;
  descricao: string | null;
  aplicaTodasLojas: boolean;
  podeVerTodasLojas: boolean;
  podePriorizarMontagem: boolean;
  podeVerMaisInfoFichaProducao: boolean;
  lojaIds: number[];
  usuarioCount: number;
  modulosAtivos: number;
  modulosTotal: number;
  protegido: boolean;
};

export type RoleAdminDetail = RoleAdminListItem & {
  screenKeys: string[];
  categories: ScreenCategoryDefinition[];
  screens: { key: string; path: string; label: string }[];
};

export type RoleCatalog = {
  categories: ScreenCategoryDefinition[];
  screens: { key: string; path: string; label: string }[];
  modulosTotal: number;
};

export type RoleAdminPayload = {
  nome: string;
  descricao?: string;
  aplicaTodasLojas: boolean;
  podeVerTodasLojas: boolean;
  podePriorizarMontagem: boolean;
  podeVerMaisInfoFichaProducao: boolean;
  lojaIds?: number[];
  screenKeys: string[];
};

export type RoleUsuarioItem = {
  id: number;
  nome: string;
  email: string;
  ativo: boolean;
  lojaId: number;
  lojaNome: string;
};

export const roleAdminService = {
  getCatalog: () => apiClient.get<RoleCatalog>("/admin/roles/catalog"),

  list: () => apiClient.get<RoleAdminListItem[]>("/admin/roles"),

  getById: (id: number) => apiClient.get<RoleAdminDetail>(`/admin/roles/${id}`),

  listUsuarios: (id: number) =>
    apiClient.get<RoleUsuarioItem[]>(`/admin/roles/${id}/usuarios`),

  create: (data: RoleAdminPayload) =>
    apiClient.post<RoleAdminDetail>("/admin/roles", data),

  update: (id: number, data: Partial<RoleAdminPayload>) =>
    apiClient.put<RoleAdminDetail>(`/admin/roles/${id}`, data),

  delete: (id: number) => apiClient.delete(`/admin/roles/${id}`),
};
